import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function ReportsFiltersProvider({ children }) {
  useInjectSaga({ key: 'reportsFiltersProvider', saga });
  useInjectReducer({ key: 'reportsFiltersProvider', reducer });

  return React.Children.only(children);
}

ReportsFiltersProvider.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withReportsFilters } from './withReportsFilters';
export default compose(withConnect, memo)(ReportsFiltersProvider);
